
try {

// SHIPPING COUNTER
var shiptimer_loaded;
$lazy('#shipping-timer', function() {
    if (!shiptimer_loaded) {
        shiptimer_loaded = true;
    
        var timer = $('#shipping-timer');

        // no container
        if (timer.length) {
                
            var truck = $('.truck-shipping', timer);
            var counter = $('.shipping-counter', timer);
            var counter_hour = $('.hour', counter);
            var counter_min = $('.min', counter);
            var counter_sec = $('.sec', counter);
            var sameday_text = $('.shipping-text.sameday', timer);
            var nextday_text = $('.shipping-text.nextday', timer);

            // start count down 
            var enddate, countInterval, date;
            var _second = 1000,
                _minute = _second * 60,
                _hour = _minute * 60,
                _day = _hour * 24,
                day;

            // toggle truck display
            var show_truck = function(state) {

                if (state) {

                    if (!countInterval) {
                        countInterval = setInterval(countdown, 1000);
                        countdown();
                    }

                    // show timer
                    timer.removeClass('nextday');
                    truck.attr('src', $zwebp(truck.data('a')));

                    counter.show();

                    sameday_text.show();
                    nextday_text.hide();

                } else {
                    timer.addClass('nextday');
                    truck.attr('src', $zwebp(truck.data('b')));

                    counter.hide();

                    sameday_text.hide();
                    nextday_text.show();
                }
            }

            function now() {
                var d = new Date();
                //d.setUTCHours(d.getUTCHours() + 2);
                return d;
            }

            function zerofill(num) {
                return ('0' + num).slice(-2);
            }

            function countdown() {
                if (!enddate) {
                    return;
                }

                date = now();

                // stop countdown
                if (enddate < date) {

                    if (countInterval) {
                        clearInterval(countInterval);
                        countInterval = false;
                    }

                    show_truck(0);
                } else {

                    var distance = enddate.getTime() - date.getTime();
                    var h = Math.floor((distance % (_day)) / (_hour));
                    var m = Math.floor((distance % (_hour)) / (_minute));
                    var s = Math.floor((distance % (_minute)) / (_second));

                    counter_hour.html(zerofill(h));
                    counter_min.html(zerofill(m));
                    counter_sec.html(zerofill(s));
                }
            }

            date = now();
            enddate = new Date();
            enddate.setUTCHours(17 - 2); // 14:00
            enddate.setUTCMinutes(0);
            enddate.setUTCSeconds(0);

            day = date.getUTCDay();

            // week day
            if (day > 0 && day < 6 && date < enddate) {
                show_truck(1);
            } else {
                show_truck(0);
                
                enddate.setDate(enddate.getDate() + 1);
                setTimeout(function() {
                    show_truck(1);
                }, enddate.getTime() - date.getTime());
            }

            window.truck = show_truck;
        }
    }
});

} catch(e){_st_catch(e)}
